import { createReducer } from '@reduxjs/toolkit';

import {
  helpersUpdateAllSectionList,
  helpersUpdateIsDashboard,
  helpersUpdateIsFirstLoadProduct,
  helpersUpdateIsLoading,
  helpersUpdateIsOpenProduct,
  helpersUpdatePlanType,
  helpersUpdateSubscriptionModalOpen,
  helpersUpdateSubscriptionModalShow,
  helperUpdateFooter,
} from './helpersActions.js';

const initialState = {
  isLoading: true,
  isDashboard: false,
  isOpenProduct: false,
  isFirstLoadProduct: false,
  allSectionList: [],
  footer: {},
  subscriptionModalOpen: false,
  planType: 'Pro',
};

const heplers = createReducer(initialState, (builder) => {
  builder
    .addCase(helpersUpdateIsLoading, (state, { payload: isLoading }) => ({ ...state, isLoading }))
    .addCase(helpersUpdateIsDashboard, (state, { payload: isDashboard }) => ({ ...state, isDashboard }))
    .addCase(helpersUpdateIsOpenProduct, (state, { payload: isOpenProduct }) => ({ ...state, isOpenProduct }))
    .addCase(helpersUpdateIsFirstLoadProduct, (state, { payload: isFirstLoadProduct }) => ({ ...state, isFirstLoadProduct }))
    .addCase(helpersUpdateAllSectionList, (state, { payload: allSectionList }) => ({ ...state, allSectionList }))
    .addCase(helperUpdateFooter, (state, { payload: footer }) => ({ ...state, footer }))
    .addCase(helpersUpdateSubscriptionModalOpen, (state, { payload: subscriptionModalOpen }) => ({ ...state, subscriptionModalOpen }))
    .addCase(helpersUpdateSubscriptionModalShow, (state) => ({ ...state, subscriptionModalOpen: true }))
    .addCase(helpersUpdatePlanType, (state, { payload: planType }) => ({ ...state, planType }));
});

export default heplers;
